import Axios from "./axios";

const resource = "promotions";

export default {
  get() {
		return Axios.get(`${resource}`);
	},
	/**
	 * Check if slug exists
	 * @param {*} slug - url slug entered by user
	 * @returns promotion info
	 */
	check(slug='') {
		return Axios.post(`${resource}/check/slug`, {slug: slug})
	},
	getViaSlug(slug, payload) {
		return Axios.get(`${resource}/show/${slug}`, payload);
	}
}